<template>
  <div class="container">
    <div class="information">
      当前就诊人：{{ defaultPatient }}
      <button @click="selectPatient">切换</button>
    </div>
    <!-- <van-tabs v-model="active" @click="checkTabs">
      <van-tab title="未缴费" name="2">
        <div class="tab-container">
          <div class="bill-item" v-for="(item, index) in payList" :key="index">
            <div class="bill-cell">
              <div class="bill-cell-label">就诊科室：</div>
              <div class="bill-cell-text">{{ item.execDeptChnDesc }}</div>
            </div>
            <div class="bill-cell">
              <div class="bill-cell-label">检测项目：</div>
              <div class="bill-cell-text">{{ item.orderDesc }}</div>
            </div>
            <div class="pay-content">
              <div class="pay-content-label">
                未付金额
                <span class="much">￥{{ item.arAmt }}</span>
              </div>
            </div>
          </div>
          <van-empty v-if="!payList.length" class="custom-image"
            image="https://img.yzcdn.cn/vant/custom-empty-image.png" description="暂无数据" />
        </div>
      </van-tab>
      <van-tab title="已缴费" name="1">
        <div class="tab-container">
          <div class="bill-item" v-for="(item, index) in payList" :key="index">
            <div class="bill-cell">
              <div class="bill-cell-label">就诊科室：</div>
              <div class="bill-cell-text">{{ item.execDeptChnDesc }}</div>
            </div>
            <div class="bill-cell">
              <div class="bill-cell-label">检测项目：</div>
              <div class="bill-cell-text">{{ item.orderDesc }}</div>
            </div>
            <div class="pay-content">
              <div class="pay-content-label">
                付款金额
                <span class="much">￥{{ item.arAmt }}</span>
              </div>
              <div class="pay-content-text" @click="goresult(item)">
                查看详情
                <van-icon name="arrow" size="16" color="#999" />
              </div>
            </div>
          </div>
          <van-empty v-if="!payList.length" class="custom-image"
            image="https://img.yzcdn.cn/vant/custom-empty-image.png" description="暂无数据" />
        </div>
      </van-tab>
    </van-tabs> -->
    <div class="tab-container">
      <div class="bill-item" v-for="(item, index) in payList" :key="index">
        <div class="bill-cell">
          <div class="bill-cell-label">就诊科室：</div>
          <div class="bill-cell-text">{{ item.execDeptChnDesc }}</div>
        </div>
        <div class="bill-cell">
          <div class="bill-cell-label">检测项目：</div>
          <div class="bill-cell-text">{{ item.orderDesc }}</div>
        </div>
        <div class="pay-content">
          <div class="pay-content-label">
            付款金额
            <span class="much">￥{{ item.arAmt }}</span>
          </div>
          <div class="pay-content-text" @click="goresult(item)">
            查看详情
            <van-icon name="arrow" size="16" color="#999" />
          </div>
        </div>
      </div>
      <van-empty
        v-if="!payList.length"
        class="custom-image"
        image="https://img.yzcdn.cn/vant/custom-empty-image.png"
        description="暂无数据"
      />
    </div>
  </div>
</template>

<script>
import { getDefaultPatient, getHrmOrder } from '@/api/api'
export default {
  data() {
    return {
      active: '1',
      defaultPatient: '',
      patientId: '',
      payList: [],
      patientIdCard: ''
    }
  },
  created() {},
  mounted() {
    if (this.$route.query.active) this.active = this.$route.query.active
    // console.log(this.active)
    // console.log(this.$route.query.active)
    //   获取就诊人
    this.getList()
  },
  methods: {
    getList() {
      getDefaultPatient().then(res => {
        if (res.data && res.data.length == 1) {
          this.defaultPatient = res.data[0].patientName
          this.patientId = res.data[0].patientId
          this.patientIdCard = res.data[0].patientIdCard
          this.getData()
        } else {
          this.defaultPatient = '暂无就诊人，请选择'
          this.patientId = ''
        }
      })
    },
    getData() {
      this.payList = []
      if (this.patientIdCard != '') {
        let data = {
          mrNo: this.patientIdCard, //病案号
          type: this.active //类型
        }
        getHrmOrder(data).then(res => {
          if (res.code == 200) {
            this.payList = res.data
          } else {
            console.error('获取核酸列表报错', res)
          }
        })
      }
    },
    selectPatient() {
      this.$router.push({
        name: 'patientList',
        query: {
          select: 'acidList'
        }
      })
    },
    goresult(item) {
      let jsbardata = {
        name: this.defaultPatient,
        money: item.ownAmt,
        mrcode: item.caseNo,
        tradNo: item.tradNo,
        refundFlag: item.refundFlag
      }
      console.log(item)
      this.$router.push({
        name: 'barcode',
        query: jsbardata
      })
    },
    checkTabs(name, title) {
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped>
.information {
  color: #ffffff;
  background-color: rgb(8, 112, 253);
  padding: 7px 10px;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.information button {
  background-color: #ffffff;
  font-size: 18px;
  color: rgb(79, 188, 251);
  border: 1px solid rgb(8, 112, 253);
  border-radius: 20px;
  padding: 3px 10px;
}

.tab-container {
  height: calc(100vh - 85px);
  background: rgb(242, 248, 253);
  overflow-y: auto;
}

.bill-item {
  width: 100vw;
  padding: 5px 15px;
  background: #fff;
  margin-bottom: 10px;

  .bill-cell {
    width: 100%;
    display: flex;
    align-items: center;
    height: 30px;

    &-label {
      width: 70px;
      color: #666;
      display: flex;
      align-items: center;
      font-size: 12px;
    }

    &-text {
      width: calc(100% - 70px);
      font-size: 12px;
    }
  }

  .pay-content {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid rgb(234, 234, 234);
    height: 50px;

    &-label {
      color: #666;
      display: flex;
      align-items: center;
      font-size: 14px;

      .much {
        font-size: 15px;
        color: rgb(237, 125, 84);
        margin-left: 10px;
      }
    }

    &-text {
      display: flex;
      align-items: center;
      font-size: 14px;
    }
  }
}
</style>
<style lang="css" scope>
.van-tabs__line {
  width: 50%;
  height: 2px;
  background-color: #3478f7;
}
</style>
